import styled from 'styled-components'

export const Sum = styled.span`
  font-weight: 700;
`

export const Li = styled.li`
  font-size: 16px;
`
